import { render, staticRenderFns } from "./LicenseManager.vue?vue&type=template&id=05478f9c&scoped=true&"
import script from "./LicenseManager.vue?vue&type=script&lang=js&"
export * from "./LicenseManager.vue?vue&type=script&lang=js&"
import style0 from "./LicenseManager.vue?vue&type=style&index=0&id=05478f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05478f9c",
  null
  
)

export default component.exports